import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "trial-sim-order-burst__caption"
};
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import TrialFundWaitingTitle from '@/components/trial-fund/TrialFundWaitingTitle.vue';
const BURST_DURATION_MS = 2200;
const LOOP_RESPAWN_MS = 1400;
export default {
  __name: 'TrialSimOrderBurst',
  props: {
    /** 每次递增触发一次撒花 */
    burstKey: {
      type: Number,
      default: 0
    },
    /** burst：短促确认；celebrate：多波烟花（中奖弹窗） */
    mode: {
      type: String,
      default: 'burst',
      validator: v => ['burst', 'celebrate'].includes(v)
    },
    /** 持续循环撒花（如下单后引导「等待开奖」附近） */
    loop: {
      type: Boolean,
      default: false
    },
    /** 爆发原点（相对视口宽高 0~1） */
    originX: {
      type: Number,
      default: 0.5
    },
    originY: {
      type: Number,
      default: 0.38
    },
    zIndex: {
      type: Number,
      default: 10050
    },
    /** 普通文案提示；celebrate / loop / waitingTitle 时不展示 */
    caption: {
      type: String,
      default: ''
    },
    /** 展示霓虹「等待开奖」标题（全语言字体，替代旧 captionSrc 图） */
    waitingTitle: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const canvasRef = ref(null);
    const active = ref(false);
    let rafId = 0;
    let hideTimer = null;
    let waveTimers = [];
    /** @type {Array<{x:number,y:number,vx:number,vy:number,w:number,h:number,rot:number,vr:number,color:string,life:number,decay:number}>} */
    let particles = [];
    let canvasSize = {
      w: 0,
      h: 0
    };
    /** @type {CanvasRenderingContext2D | null} */
    let drawCtx = null;
    let loopAlive = false;
    const COLORS = ['#1f53f9', '#22c55e', '#f59e0b', '#ef4444', '#a855f7', '#06b6d4', '#f97316', '#fbbf24'];

    /** burst 模式彩带 / 文案统一时长 */
    const showWaitingTitle = computed(() => {
      if (props.mode === 'celebrate' || props.loop) return false;
      return Boolean(props.waitingTitle);
    });
    const captionText = computed(() => {
      if (props.mode === 'celebrate' || props.loop || showWaitingTitle.value) return '';
      return String(props.caption || '').trim();
    });
    function clearTimers() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
      if (hideTimer != null) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      for (const id of waveTimers) clearTimeout(id);
      waveTimers = [];
    }
    function resizeCanvas(canvas) {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = window.innerWidth;
      const h = window.innerHeight;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      const ctx = canvas.getContext('2d');
      if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      canvasSize = {
        w,
        h
      };
      drawCtx = ctx;
      return {
        w,
        h,
        ctx
      };
    }

    /**
     * @param {number} cx
     * @param {number} cy
     * @param {number} count
     */
    function spawnAt(cx, cy, count) {
      for (let i = 0; i < count; i += 1) {
        const angle = Math.PI * 2 * i / count + (Math.random() - 0.5) * 0.4;
        const speed = 3 + Math.random() * 9;
        particles.push({
          x: cx + (Math.random() - 0.5) * 12,
          y: cy,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 1.5,
          w: 4 + Math.random() * 5,
          h: 7 + Math.random() * 8,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.4,
          color: COLORS[i % COLORS.length],
          life: 1,
          decay: 0.008 + Math.random() * 0.008
        });
      }
    }

    /**
     * @param {number} w
     * @param {number} h
     */
    function spawnBurstAtOrigin(w, h) {
      const cx = w * Math.min(1, Math.max(0, Number(props.originX) || 0.5));
      const cy = h * Math.min(1, Math.max(0, Number(props.originY) || 0.38));
      for (let i = 0; i < 72; i += 1) {
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2;
        const speed = 6 + Math.random() * 10;
        particles.push({
          x: cx + (Math.random() - 0.5) * 40,
          y: cy,
          vx: Math.cos(angle) * speed + (Math.random() - 0.5) * 4,
          vy: Math.sin(angle) * speed - 2,
          w: 5 + Math.random() * 5,
          h: 8 + Math.random() * 8,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.35,
          color: COLORS[i % COLORS.length],
          life: 1,
          decay: 0.009
        });
      }
    }
    function tick() {
      const ctx = drawCtx;
      const {
        w,
        h
      } = canvasSize;
      if (!ctx) return;
      ctx.clearRect(0, 0, w, h);
      let alive = false;
      for (let i = 0; i < particles.length; i += 1) {
        const p = particles[i];
        p.vy += 0.18;
        p.vx *= 0.994;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.life -= p.decay;
        if (p.life <= 0) continue;
        alive = true;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, p.life);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      particles = particles.filter(p => p.life > 0);
      if (alive || waveTimers.length || hideTimer != null || loopAlive) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = 0;
      }
    }
    function ensureLoop() {
      if (!rafId) rafId = requestAnimationFrame(tick);
    }
    function scheduleLoopRespawn(canvas) {
      const id = setTimeout(() => {
        waveTimers = waveTimers.filter(t => t !== id);
        if (!loopAlive || !props.loop) return;
        const {
          w,
          h,
          ctx
        } = resizeCanvas(canvas);
        if (!ctx) return;
        spawnBurstAtOrigin(w, h);
        ensureLoop();
        scheduleLoopRespawn(canvas);
      }, LOOP_RESPAWN_MS);
      waveTimers.push(id);
    }
    function stopBurst() {
      loopAlive = false;
      clearTimers();
      if (drawCtx) drawCtx.clearRect(0, 0, canvasSize.w, canvasSize.h);
      particles = [];
      active.value = false;
    }
    async function runBurst() {
      clearTimers();
      particles = [];
      active.value = true;
      loopAlive = Boolean(props.loop);
      await nextTick();
      const canvas = canvasRef.value;
      if (!canvas) {
        active.value = false;
        loopAlive = false;
        return;
      }
      const {
        w,
        h,
        ctx
      } = resizeCanvas(canvas);
      if (!ctx) {
        active.value = false;
        loopAlive = false;
        return;
      }
      const celebrate = props.mode === 'celebrate';
      if (props.loop) {
        spawnBurstAtOrigin(w, h);
        ensureLoop();
        scheduleLoopRespawn(canvas);
      } else if (celebrate) {
        const waves = [{
          delay: 0,
          x: 0.5,
          y: 0.32,
          n: 56
        }, {
          delay: 280,
          x: 0.28,
          y: 0.42,
          n: 40
        }, {
          delay: 520,
          x: 0.72,
          y: 0.4,
          n: 40
        }, {
          delay: 820,
          x: 0.5,
          y: 0.28,
          n: 48
        }, {
          delay: 1100,
          x: 0.35,
          y: 0.5,
          n: 36
        }, {
          delay: 1400,
          x: 0.65,
          y: 0.48,
          n: 36
        }];
        for (const wave of waves) {
          const id = setTimeout(() => {
            spawnAt(w * wave.x, h * wave.y, wave.n);
            ensureLoop();
          }, wave.delay);
          waveTimers.push(id);
        }
        ensureLoop();
        hideTimer = setTimeout(() => {
          hideTimer = null;
          for (const id of waveTimers) clearTimeout(id);
          waveTimers = [];
          const finishId = setTimeout(() => {
            clearTimers();
            if (drawCtx) drawCtx.clearRect(0, 0, canvasSize.w, canvasSize.h);
            particles = [];
            active.value = false;
          }, 1600);
          waveTimers.push(finishId);
        }, 3200);
      } else {
        spawnBurstAtOrigin(w, h);
        ensureLoop();
        hideTimer = setTimeout(() => {
          hideTimer = null;
          clearTimers();
          if (drawCtx) drawCtx.clearRect(0, 0, canvasSize.w, canvasSize.h);
          particles = [];
          active.value = false;
        }, BURST_DURATION_MS);
      }
    }
    watch(() => props.burstKey, key => {
      if (key > 0) runBurst();
    }, {
      immediate: true
    });
    watch(() => props.loop, (on, was) => {
      if (on && !was) runBurst();
      if (!on && was) stopBurst();
    });
    onBeforeUnmount(stopBurst);
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "trial-sim-order-burst",
        style: _normalizeStyle({
          zIndex: String(__props.zIndex)
        }),
        "aria-hidden": "true"
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        class: "trial-sim-order-burst__canvas"
      }, null, 512), showWaitingTitle.value ? (_openBlock(), _createBlock(TrialFundWaitingTitle, {
        key: 0,
        "root-class": "trial-sim-order-burst__waiting-title"
      })) : captionText.value ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(captionText.value), 1)) : _createCommentVNode("", true)], 4)), [[_vShow, active.value]]);
    };
  }
};